<template>
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7913_8144)">
      <path
        d="M21.3073 21.7202L22.8383 20.1892L16.5714 13.9219V5.10986H14.4286V14.8415L21.3073 21.7202ZM15.5028 30C13.4365 30 11.4943 29.6096 9.67615 28.8288C7.85799 28.0481 6.26466 26.9738 4.89617 25.6059C3.52765 24.238 2.45282 22.6434 1.67169 20.8221C0.890565 19.0008 0.5 17.0547 0.5 14.9839C0.5 12.9131 0.890386 10.966 1.67116 9.14269C2.45193 7.31936 3.52624 5.73032 4.89411 4.37556C6.26199 3.02078 7.8566 1.95282 9.67792 1.17169C11.4992 0.390566 13.4453 0 15.5161 0C17.5869 0 19.5341 0.393684 21.3576 1.18105C23.1811 1.96841 24.7672 3.03696 26.1161 4.38669C27.465 5.73644 28.5329 7.32366 29.3197 9.14834C30.1066 10.973 30.5 12.9226 30.5 14.9972C30.5 17.0635 30.1096 19.0057 29.3288 20.8238C28.5481 22.642 27.4806 24.2353 26.1265 25.6038C24.7723 26.9724 23.1822 28.0472 21.3562 28.8283C19.5301 29.6094 17.579 30 15.5028 30ZM15.5197 27.8572C19.0767 27.8572 22.1056 26.6003 24.6062 24.0866C27.1069 21.5728 28.3572 18.5374 28.3572 14.9803C28.3572 11.4233 27.1069 8.39442 24.6062 5.89378C22.1056 3.39314 19.0767 2.14282 15.5197 2.14282C11.9626 2.14282 8.92718 3.39314 6.41344 5.89378C3.89969 8.39442 2.64282 11.4233 2.64282 14.9803C2.64282 18.5374 3.89969 21.5728 6.41344 24.0866C8.92718 26.6003 11.9626 27.8572 15.5197 27.8572Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7913_8144">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>